// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../../../i18n/l10n';
import { GridTypes } from '../../types';
import type { GridType } from '../../types';
import TypeFilter from '../buttons/TypeFilter';

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  margin: 0.4em 0;
`;

const StyledFilter = styled(TypeFilter)`
  && {
    margin: 0 0.6em;

    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

type GridsTypeTabsProps = {
  className?: string;
  setPersonal?: () => void;
  setTeam?: () => void;
  noPersonal?: boolean;
  isDark?: boolean;
  gridType: GridType;
};

const GridsTypeTabs = ({
  className,
  setPersonal,
  setTeam,
  isDark,
  noPersonal = false,
  gridType,
}: GridsTypeTabsProps) => {
  return (
    <Wrap className={className}>
      {!noPersonal && (
        <StyledFilter
          isDark={isDark}
          isSelected={gridType === GridTypes.PERSONAL}
          onClick={setPersonal}
          data-testid="grid-personal-button"
        >
          {__('Individual grid')}
        </StyledFilter>
      )}
      <StyledFilter
        isDark={isDark}
        isSelected={gridType === GridTypes.TEAM}
        onClick={setTeam}
        data-testid="grid-team-button"
      >
        {__('Team grid')}
      </StyledFilter>
    </Wrap>
  );
};

export default GridsTypeTabs;
